import { showAppToast } from './utils';

// Use the same display queue for page feedback and actionable transition notifications.
export const appToast = {
  success: (title: string): void => showAppToast({ title, tone: 'success' }),
  error: (title: string): void => showAppToast({ title, tone: 'error' }),
};
